import script from "./PwaNotice.vue?vue&type=script&setup=true&lang=ts"
export * from "./PwaNotice.vue?vue&type=script&setup=true&lang=ts"

import "./PwaNotice.vue?vue&type=style&index=0&id=04225b2b&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04225b2b"]])

export default __exports__